<!--客户跟进记录-->
<template>
    <div class="order-infoTab-section" v-loading="loading">
        <div class="order-hd">
            <a href="javascript:;" @click="writeTrace" v-if="Acs('/customer/traces/create')" >+添加跟进记录</a>
        </div>
        <div class="order-bd" >
            <el-steps direction="vertical">
                <el-step icon="el-icon-fa-user" v-for="(trace, index) in traces" :key="index" >
                    <div slot="title" class="title-step" >
                        <span>{{trace.username}}</span>
                        <span>联系人：{{trace.contact_name}}</span>
                        <span>跟进产品：{{trace.product_name}}</span>
                        <span>跟进时间：{{trace.created_at}}</span>
                        <span v-if="trace.next_time">下次跟进时间：{{trace.next_time}}</span>
                    </div>
                    <div slot="description" class="des-step" >
                        <div>详细内容：{{trace.content}}</div>
                    </div>
                </el-step>
            </el-steps>
        </div>

        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
        </el-row>

        <!--跟进组件-->
        <trace-modal
                :show-dialog="showTraceModal"
                :customer-id="parseInt(customerId)"
                @closeModal="closeModal"
                @saveCallback="saveCallback"
        >
        </trace-modal>
        <!-- 跟进组件 EOF -->
    </div>
</template>

<script>
    import CustomerTraceService from "~/services/CustomerTrace";
    import Pagination from "~/widgets/Pagination.vue";
    import TraceModal from "~/views/tasks/TraceModal.vue";

    export default {
        name: "CustomerTraces",
        components: {
            Pagination,
            TraceModal
        },
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
        },
        watch : {
            customerId: function (value, original) {
                this.getTraces({customer_id: value});
            },
        },
        data() {
            return {
                traces: [],
                loading: true,
                // 分页信息
                linkPage: null,
                // 监听控制跟进填写表单对话框显示
                showTraceModal: false,
            };
        },
        created: function() {

            if (this.traces.length < 1 && this.customerId > 0) {
                this.getTraces({
                    customer_id: this.customerId
                });
            }
        },
        methods: {
            getTraces(params) {
                CustomerTraceService.getList(params).then(res => {
                    if (res && res.data) {
                        this.traces = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    console.error(err);
                })
            },

            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchPageChange(pageParams) {
                this.getTraces({
                    customer_id: this.customerId,
                    page: pageParams["page"],
                    perPage: pageParams["perPage"]
                });
            },

            // 监听对话框关闭事件
            closeModal(isShow) {
                this.showTraceModal = isShow;
                //this.isFinished = isShow;
            },

            // 填写跟进
            writeTrace() {
                // 显示跟进表单对话框
                this.showTraceModal = true;
            },

            // 跟进记录提交保存后触发的回调
            saveCallback() {
                // 重新加载跟进列表
                this.getTraces({customer_id: this.customerId})
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/customer/Traces.vue